import React from 'react';

export const AuthContext = React.createContext({
    isLoggedIn: false,
    isConnected: false,
    token: undefined,
    address: null,
    register: () => {},
    login: () => {},
    logout: () => {}
});
